import { DismissibleRoot } from './DismissibleRoot'
import { DismissibleTrigger } from './DismissibleTrigger'

export const Dismissible = Object.assign(DismissibleRoot, {
  Trigger: DismissibleTrigger
})
